"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isFolderOrSubFolderOfDistinguishedFolder_1 = require("owa-mail-store/lib/utils/isFolderOrSubFolderOfDistinguishedFolder");
var MoveKind;
(function (MoveKind) {
    MoveKind[MoveKind["Normal"] = 0] = "Normal";
    MoveKind[MoveKind["ShadowMailbox_Copy"] = 1] = "ShadowMailbox_Copy";
    MoveKind[MoveKind["ShadowMailbox_Delete"] = 2] = "ShadowMailbox_Delete";
})(MoveKind = exports.MoveKind || (exports.MoveKind = {}));
var isOrUnderJunkOrDeleted = function (folder) {
    return isFolderOrSubFolderOfDistinguishedFolder_1.default(folder, 'deleteditems') ||
        isFolderOrSubFolderOfDistinguishedFolder_1.default(folder, 'junkemail');
};
exports.default = function (isShadowMailbox, sourceFolder, destinationFolder) {
    if (!isShadowMailbox) {
        return 0 /* Normal */;
    }
    else if (sourceFolder.sourceWellKnownFolderType == 86 /* AllMail */ &&
        !isOrUnderJunkOrDeleted(destinationFolder)) {
        return 1 /* ShadowMailbox_Copy */;
    }
    else if (!isOrUnderJunkOrDeleted(sourceFolder) &&
        destinationFolder.sourceWellKnownFolderType == 86 /* AllMail */) {
        return 2 /* ShadowMailbox_Delete */;
    }
    else {
        return 0 /* Normal */;
    }
};
//# sourceMappingURL=getMoveKind.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/getMoveKind.js
// module id = 5599
// module chunks = 62